export default __webpack_public_path__ + "static/media/Management.dc4b1092.png";